import React from "react";
import { useTranslation } from "react-i18next";

import { tracking } from "../../app/services/tracking";
import { Markdown } from "../shared/Markdown";

import "./AssistanceHotlinePush.scss";

const classNamePrefix = "AssistanceHotlinePush";

export const AssistanceHotlinePush = () => {
  const [context, setContext] = React.useState(
    "INACTIVE" as "ACTIVE" | "INACTIVE",
  );

  const { t } = useTranslation();
  const { action, text } = t("features.assistance.AssistanceHotlinePush", {
    context,
  }) as unknown as {
    action: { href: string; label: string; text: string };
    text: string;
  };

  const { eventLabel, onClick } = {
    ACTIVE: {
      eventLabel: "tel-support-client",
      onClick: () => window.open(action.href, "_self"),
    },
    INACTIVE: {
      eventLabel: "contactez_nous",
      onClick: () => setContext("ACTIVE"),
    },
  }[context];

  return (
    <div className={classNamePrefix}>
      <div className={`${classNamePrefix}-action`}>
        <button
          aria-label={action.label}
          aria-live="polite"
          type="button"
          onClick={() => {
            onClick();

            tracking.trackEvent({
              eventAction: "clic",
              eventCategory: "pre-home",
              eventLabel,
            });
          }}
        >
          {action.text}
        </button>
      </div>
      <div className={`${classNamePrefix}-text`}>
        <Markdown>{text}</Markdown>
      </div>
    </div>
  );
};
